module.exports = "<div style=\"padding: 5px;\">\r\n{{kendo-date-picker value=issueDate  format=controller.dateFormat}}\r\n  </div>"